import React from "react";
import ReactDOM from "react-dom";
import config from "./config";
import { Application } from './application/Application';

ReactDOM.render(<Application config={config} />, document.getElementById("root"));
